import { render, staticRenderFns } from "./LabelListItem.vue?vue&type=template&id=95d508c6&scoped=true"
import script from "./LabelListItem.vue?vue&type=script&lang=js"
export * from "./LabelListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d508c6",
  null
  
)

export default component.exports